/**
 * Smart-rotation row shown beneath the group header (Voluum parity).
 * Tooltip explains the behaviour, mirroring Voluum's help text.
 */

import { useId, type FC } from 'react';
import { HelpCircle } from 'lucide-react';

import { Checkbox } from '@/components/ui/form/controls/Checkbox';
import { Tooltip } from '@/components/ui/Tooltip';

export interface SmartRotationRowProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  ariaLabel: string;
}

const SMART_ROTATION_HINT =
  'If enabled, users will be automatically redirected to a new path / lander / offer of this campaign that they have not seen yet.';

const SmartRotationRow: FC<SmartRotationRowProps> = ({
  checked,
  onChange,
  ariaLabel,
}) => {
  const id = useId();

  return (
    <div
      className="flex items-center gap-2 px-2 py-1"
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Checkbox
        id={id}
        className="h-3.5 w-3.5 shrink-0"
        checked={checked}
        onCheckedChange={(v) => onChange(v === true)}
        aria-label={ariaLabel}
      />
      <label
        htmlFor={id}
        className="flex min-w-0 cursor-pointer items-center gap-1 text-[11px] font-medium text-foreground"
      >
        Smart rotation
        <Tooltip content={SMART_ROTATION_HINT}>
          <HelpCircle
            className="h-3 w-3 shrink-0 text-muted-foreground"
            aria-label="About smart rotation"
          />
        </Tooltip>
      </label>
    </div>
  );
};

export default SmartRotationRow;
